<p-dialog
  data-testid="cookieConsentDialog"
  [header]="header ? header : ('CookieConsent.Title' | translate)"
  [(visible)]="isVisible"
  [modal]="true"
  [breakpoints]="{'960px': '95vw'}"
  [style]="{width: '50vw'}"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  (onHide)="onHideCookieConsentModal()"
  class="cookie-consent-dialog">
  <app-cookie-consent-form
    [hidden]="showState !== ECookieConsent.Consent"
    [shouldShowSettings]="shouldShowSettings"
    (hideConsentModal)="onHideCookieConsentModal()"
    (showMoreInformation)="onShowMoreInformation($event)"
    (shouldShowAllowSelection)="onShouldShowAllowSelection($event)" />

  <app-cookie-type
    [hidden]="showState !== ECookieType.StrictlyNecessary"
    [cookies]="strictlyNecessaryCookies"
    [title]="'CookieConsent.StrictlyNecessary.Title' | translate"
    (backToCookieSettings)="onBackToCookieSettings()" />

  <ng-template pTemplate="footer">
    @if (showState === ECookieConsent.Consent) {
<div class="footer flex justify-content-end w-full">
      <div class="grid w-full">
        <div class="col-12 flex">
          <p-divider styleClass="p-divider-mg-teal" class="m-0 p-0 p-element pr-2 w-full" />
        </div>
        <div class="col-12 flex">
          <div class="col-3"></div>
          <div class="col-9 justify-content-end align-items-end flex p-0">
            @if (!shouldShowAllowSelection) {
<p-button data-testid="allowNeccessaryCookies"
             
              [label]="'CookieConsent.NecessaryCookies' | translate"
              styleClass="p-button-rounded"
              class="p-0"
              (onClick)="onAllowNecessaryCookies()" />
}
            @if (shouldShowAllowSelection) {
<p-button data-testid="allowSelectionCookies"
             
              [label]="'CookieConsent.AllowSelection' | translate"
              styleClass="p-button-rounded"
              class="p-0"
              (onClick)="onAllowSelectionCookies()" />
}

            <p-button data-testid="allowAllCookies"
              icon="pi pi-check"
              iconPos="right"
              [label]="'CookieConsent.AllowAllCookies' | translate"
              styleClass="p-button-rounded"
              class="p-0"
              (onClick)="onAllowAllCookies()" />
          </div>
        </div>
      </div>
    </div>
}
    @if (showState !== ECookieConsent.Consent) {
<div class="col-12">
      <div class="grid w-full">
        <div class="col-12 flex">
          <p-divider styleClass="p-divider-mg-teal" class="m-0 p-0 p-element pr-2 w-full" />
        </div>
        <div class="col-12 flex justify-content-end">
          <p-button [label]="'CookieConsent.Back' | translate"
            styleClass="p-button-outlined p-button-rounded"
            class="p-2"
            (onClick)="onBackToCookieSettings()" />
        </div>
      </div>
    </div>
}
  </ng-template>
</p-dialog>
